import number from '@/common/format/number';

export default function (amount, currency) {
    if (typeof amount !== 'number') {
        const amountToNumber = parseFloat(amount);
        if (isNaN(amountToNumber)) {
            return amount;
        }
        amount = amountToNumber;
    }

    return number(amount, {style: 'currency', currency});
}
